<template>
  <SelectWithSearch
    label="Incidência"
    labelBusca="description"
    placeholder="Pesquise a incidência"
    v-model="input"
    :disabled="disabled"
    :clearable="clearable"
    :change="change"
    :options="options"
  >
    <template slot="options" slot-scope="props">
      <div class="selected">{{ props.data.description }}</div>
    </template>
    <template slot="no-options"> Selecione a incidência </template>
    <template slot="selected" slot-scope="props">
      <div class="selected">{{ props.data.description }}</div>
    </template>
  </SelectWithSearch>
</template>

<script>
import { SelectWithSearch } from '@/components/Form';

export default {
  name: 'SelectIncidence',
  components: {
    SelectWithSearch,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    default: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    value: {},
  },
  data() {
    return {
      options: [
        { id: 0, description: 'Tomador' },
        { id: 1, description: 'Prestador' },
      ],
      input: null,
    };
  },
  mounted() {
    if (this.default) {
      const [defaultOption] = this.options;
      this.$emit('input', defaultOption);
    }
  },
  methods: {
    change(value) {
      this.$emit('input', value);
    },
  },
  watch: {
    value(current) {
      this.input = current;
    },
  },
};
</script>
